var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenDarkTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56051 0C3.8327 0 0 3.58175 0 8C0 12.4185 3.8327 16 8.56051 16C13.2886 16 17.121 12.4185 17.121 8C17.121 3.58175 13.2886 0 8.56051 0ZM8.56051 15.0157C4.43033 15.0157 1.07006 11.8597 1.07006 7.99997C1.07006 4.14022 4.43033 0.999969 8.56051 0.999969C12.6907 0.999969 16.051 4.14023 16.051 7.99997C16.051 11.8597 12.6907 15.0157 8.56051 15.0157ZM11.977 5.07275L6.95433 9.796L4.69248 7.68225C4.48355 7.487 4.14488 7.487 3.93568 7.68225C3.72675 7.8775 3.72675 8.194 3.93568 8.38925L6.58382 10.8643C6.79275 11.0592 7.13142 11.0592 7.34062 10.8643C7.3647 10.8418 7.38531 10.8172 7.40404 10.7917L12.734 5.77998C12.9427 5.58473 12.9427 5.26823 12.734 5.07275C12.5248 4.8775 12.1862 4.8775 11.977 5.07275Z",
    fill: "#326641"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDarkTick);
export default __webpack_public_path__ + "static/media/green-dark-tick.db001fdafd1301d8c37d84bf013ede11.svg";
export { ForwardRef as ReactComponent };